document.addEventListener('DOMContentLoaded', () => {
    const selects = document.querySelectorAll('.select');
    
    selects.forEach(select => {
        const selectCurrent = select.querySelector('.select-current span');
        const selectList = select.querySelector('.select-options');
        const selectItem = select.querySelectorAll('.select-option');
        
        select.addEventListener('click', () => {
            selectList.classList.toggle('active');
        });
        
        selectItem.forEach(item => {
            item.addEventListener('click', () => {
                selectCurrent.innerHTML = item.innerHTML;
                selectList.classList.remove('active');
            });
        });
        
        document.addEventListener('click', (e) => {
            if (!select.contains(e.target)) {
                selectList.classList.remove('active');
            }
        });
    });
});